import { render, staticRenderFns } from "./ListBankaccounts.vue?vue&type=template&id=4fa8767e&"
import script from "./ListBankaccounts.vue?vue&type=script&lang=js&"
export * from "./ListBankaccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports